import { render, staticRenderFns } from "./DepartmentForbidden.vue?vue&type=template&id=5eef129c&"
import script from "./DepartmentForbidden.vue?vue&type=script&lang=js&"
export * from "./DepartmentForbidden.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports